export default "__VITE_ASSET__DVsDJLIN__"